import React from 'react';
import DeliverySettings from '../../components/DeliverySettings';

const UberEats = () => {
	return (
		<DeliverySettings
			channelId="uber-eats"
			hasOpeningHours
			fields={[
				{
					id: 'storeId',
					label: 'Store ID',
					placeholder: '00000-000000-00000-00000'
				}
			]}
		/>
	);
};

export default UberEats;
